import { connect } from 'react-redux';

import { checkCredentials, clearInputError, setInputError } from '../actions/GenericActions';
import { fetchInputsAndDeclaredContacts, updateContacts } from '../actions/AddContactActions';
import AddContactView from '../components/Steps/AddContact/AddContactView';

const mapDispatchToProps = dispatch => ({
  fetchInputsAndDeclaredContacts: () => dispatch(fetchInputsAndDeclaredContacts()),
  updateContacts: ({ mail, mobile, checked }) => dispatch(updateContacts({ mail, mobile, checked })),
  setInputError: ({ field, error }) => dispatch(setInputError({ field, error })),
  clearInputError: ({ field }) => dispatch(clearInputError({ field })),
  checkCredentials: (field, value) => dispatch(checkCredentials(field, value)),
});

const mapStateToProps = state => ({
  isLoading: state.generic.request.isLoading,
  showMobile: state.add.showMobile,
  showMail: state.add.showMail,
  errors: state.add.errors,
  declared: state.add.declared,
});

export default connect(mapStateToProps, mapDispatchToProps)(AddContactView);
